import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfigurationService} from '../../services/configuration.service';
import {Clipboard} from '@angular/cdk/clipboard';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CommonComponent} from '../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {DialogService} from 'primeng/dynamicdialog';
import {AccountService} from '../../services/account.service';
import {ApplicationService} from '../../services/application.service';
import {environment} from '../../../environments/environment';
import {Platform} from '@angular/cdk/platform';

@Component({
  selector: 'app-mobile-app',
  templateUrl: './mobile-app.component.html',
  styleUrls: ['./mobile-app.component.scss']
})

export class MobileAppComponent extends CommonComponent implements OnInit {
  validation: object;
  changeImage = false;
  productName = environment.programName;
  androidStoreURL: string = environment.androidStore;
  iosStoreURL: string = environment.iosStore;
  referredCodeParam: string;
  useHub = environment.hubInMobileApp;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    private activatedRoute: ActivatedRoute,
    private applicationService: ApplicationService,
    public configurationService: ConfigurationService,
    private clipboard: Clipboard,
    private accountService: AccountService,
    public translate: TranslateService,
    public platform: Platform,
    private route: ActivatedRoute,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    router: Router,
    protected dialogService: DialogService,
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    if (this.useHub){
      this.productName = environment.programNameHub;
      this.iosStoreURL = environment.hubIosStore;
      this.androidStoreURL = environment.hubAndroidStore;
    }
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.handleLanguageChange(event.lang);
      });
  }

  ngOnInit(): void {
    this.configurationService.getPlatformConfigService().subscribe(
      (response: any) => {
        this.referredCodeParam = this.route.snapshot.paramMap.get('code');
        const externalReferenceCode: string = this.route.snapshot.queryParamMap.get('externalReferenceCode');
        let dataReferredCode: string = null;
        let dataExternalReferenceCode: string = null;

        if (this.referredCodeParam !== null && this.referredCodeParam !== '') {
          dataReferredCode = `referredCode%3D${this.referredCodeParam}`;
        }

        if (externalReferenceCode !== null && externalReferenceCode !== '') {
          dataExternalReferenceCode = `externalReferenceCode%3D${externalReferenceCode}`;
        }

        if (dataReferredCode !== null || dataExternalReferenceCode !== null) {
          this.androidStoreURL = `${this.androidStoreURL}&referrer=${dataReferredCode ?? ''}${dataReferredCode !== null && dataExternalReferenceCode != null ? '%26' : ''}${dataExternalReferenceCode ?? ''}`;
        }

        if (this.platform.IOS) {
          window.location.href = `${this.iosStoreURL}`;
        }
        if (this.platform.ANDROID) {
          window.location.href = `${this.androidStoreURL}`;
        }

      }
    );
  }

  handleLanguageChange(lang: string) {
    this.changeImage = lang === 'en';
  }
}
